import './schedule-filter.scss';

import Component from '../component/component';

export default class ScheduleFilter extends Component {
    static initSelector: string = '.schedule-filter';

    public nextButton: HTMLElement;
    public prevButton: HTMLElement;
    public choicesContainer: HTMLElement;
    public choicesInnerContainer: HTMLElement;
    public dayPicker: HTMLElement;
    public choices: NodeListOf<HTMLElement>;
    public selectedChoice: HTMLElement;
    public scrollAmount: number = 0;
    public radioChoices: NodeListOf<HTMLElement>;

    constructor(target: HTMLElement) {
        super(target);

        this.nextButton = this.element.querySelector('.schedule-filter__day-picker-next');
        this.prevButton = this.element.querySelector('.schedule-filter__day-picker-prev');
        this.choicesContainer = this.element.querySelector('.schedule-filter__day-picker-container');
        this.choicesInnerContainer = this.element.querySelector('.schedule-filter__day-picker-outer');
        this.choices = this.element.querySelectorAll('.day-picker__choice');
        this.selectedChoice = this.element.querySelector('.day-picker__input:checked');
        this.dayPicker = this.element.querySelector('.schedule-filter__day-picker');
        this.radioChoices = this.element.querySelectorAll('.filter-radio__choice');

        if (this.dayPicker) {
            this.init();
        }

        if (this.radioChoices) {
            this.handleFilterRadios();
            this.radioChoices.forEach((element: HTMLElement) => element.addEventListener('click', this.handleFilterRadios.bind(this)));
        }
    }

    init(): void {
        setTimeout(() => {
            this.scrollToSelectedDate();
        }, 100);
        this.handleArrows();
        this.handleClicks();
    }

    hasOverflow(): boolean {
        return this.choicesContainer.offsetWidth < this.dayPicker.offsetWidth;
    }

    handleArrows(): void {
        if (this.hasOverflow()) {
            this.nextButton.classList.remove('h-hidden');
            this.prevButton.classList.remove('h-hidden');
        }
    }

    scrollToSelectedDate(): void {
        const selectedChoiceOffset: number = this.selectedChoice.getBoundingClientRect().left;
        const choiceContainerOffset: number = this.choicesContainer.getBoundingClientRect().left;
        // calculate selected choice's distance from the choices' container
        const offsetDifference: number = selectedChoiceOffset - choiceContainerOffset;
        const scrollMax: number = this.dayPicker.offsetWidth + 112;
        const containerWidth: number = this.choicesContainer.offsetWidth;
        const choiceWidth: number = this.choices[0].offsetWidth;

        // add choice's width to offset difference to make sure choice will be fully visible
        if ((offsetDifference + choiceWidth) > containerWidth) {
            this.choicesContainer.scrollTo({
                behavior: 'auto',
                left: Math.min(offsetDifference, scrollMax),
                top: 0,
            });

            this.scrollAmount = Math.min(offsetDifference, scrollMax);
        }
    }

    handleClicks(): void {
        const scrollMin: number = 0;
        const scrollMax: number = this.dayPicker.offsetWidth + 112;
        const containerWidth: number = this.choicesContainer.offsetWidth;

        this.nextButton.onclick = (): void => {
            // prevent scroll amount overcharging that would lead to multiple clicks to activate scroll
            if (this.scrollAmount < scrollMin) {
                this.scrollAmount = scrollMin;
            }

            this.choicesContainer.scrollTo({
                behavior: 'smooth',
                left: Math.min(this.scrollAmount += containerWidth, scrollMax),
                top: 0,
            });
        };

        this.prevButton.onclick = (): void => {
            // prevent scroll amount overcharging that would lead to multiple clicks to activate scroll
            if (this.scrollAmount > scrollMax) {
                this.scrollAmount = scrollMax;
            }
            this.choicesContainer.scrollTo({
                behavior: 'smooth',
                left: Math.max(this.scrollAmount -= containerWidth, scrollMin),
                top: 0,
            });
        };
    }

    handleFilterRadios(): void {
        this.radioChoices.forEach((element: HTMLElement) => {
            if (element.hasAttribute('data-fields')) {
                const fieldIDs: string[] = element.getAttribute('data-fields').split(',');
                const isChecked: boolean = element.querySelector('input').checked;

                fieldIDs.forEach((id: string) => {
                    const dropdown: HTMLElement = this.element.querySelector(`#dropdown-parent-${id}`);

                    if (isChecked) {
                        dropdown.classList.remove('h-hidden');
                    } else {
                        dropdown.classList.add('h-hidden');
                    }
                });
            }
        });
    }
}
